import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'widg-session-calendar',
  templateUrl: './widg-session-calendar.component.html',
  styleUrls: ['./widg-session-calendar.component.scss']
})
export class WidgSessionCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
